import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

import Home from "@/pages/Home";
import Fulfillment from "@/pages/Fulfillment";
import Promotional from "@/pages/Promotional";
import TradeShow from "@/pages/TradeShow";
import EventManagement from "@/pages/EventManagement";
import MarketingCollateral from "@/pages/MarketingCollateral";
import PrintingServices from "@/pages/PrintingServices";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ClientPortal from "@/pages/ClientPortal";
import FulfillmentPortal from "@/pages/FulfillmentPortal";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Accessibility from "@/pages/Accessibility";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fulfillment-warehousing" element={<Fulfillment />} />
            <Route path="/promotional-products-apparel" element={<Promotional />} />
            <Route path="/trade-show-exhibits" element={<TradeShow />} />
            <Route path="/event-project-management" element={<EventManagement />} />
            <Route path="/marketing-collateral" element={<MarketingCollateral />} />
            <Route path="/printing-services" element={<PrintingServices />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/client-portal" element={<ClientPortal />} />
            <Route path="/client-portal/fulfillment" element={<FulfillmentPortal />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
